import React from 'react';
import CustomRouter from "./CustomRouter";

function App() {
  return (
    <CustomRouter />
  );
}
 
export default App;
